import React from 'react';
import { Container} from '@mui/material';
import Header from '../components/layout/Header';
import DonCatastrophesForm from '../components/forms/DonCatastrophesForm';

const DonCatastrophes = () => {
  
  return (
    <>
      <Header />
      <Container maxWidth="md" sx={{ mt: {xs: 2, md :0}, px: { xs: 1, sm: 2 } }}>
        <DonCatastrophesForm />
      </Container>
    </>
  );
};

export default DonCatastrophes;